export enum MediaFormatEnum {
  SQUARE = 'SQUARE',
  RECTANGULAR = 'RECTANGULAR',
}
